import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  PreviewLetterWrapper,
  PreviewLetterContent,
  LetterWrapper,
  PreviewFlex
} from "../styles";
import { LogoWrap } from "../../../../styles";
import { PreviewLetterLogo } from "../../../../../RecommendGrant/Component/ViewEditSchedules/style";
import PreviewLetterImage from "../../../../../../../../assets/icons/preview-letter.svg";
import { DisplayFlex } from "../../../../../../../../CommonComponents/commonStyles";
import { GrantAgreementUnderlineLink, Block } from "../../../../styles";
import PreviewLetterPopup from "../../../GrantAgreementLetter/GrantAgreementDocumentPreview/GrantAgreementDocPreview";
import PreviewLetter from "../../../GrantPreviewLetter/GrantPreviewLetter";
import { recordError } from "../../../../../../../../utils/commonUtil";

class PreviewLetters extends Component {
  state = {
    grantPaymentData: {
      organizationName: "",
      granteeName: "",
      grantPurpose: "",
      grantAmount: "",
      accountName: "",
      ein: "",
      payments: [],
      reportingFromOrganization: false,
      anonymous: true
    },
    previewPopup: false
  };
  componentDidMount() {
    let grantAgreement = this.state;
    let paymentList = this.paymentFormatter();
    let dueList = this.dueDateFormatter();

    grantAgreement.grantPaymentData.organizationName = this.props.selectedCharityName;
    grantAgreement.grantPaymentData.organizationAddress = this.props.selectedCharityAddress;
    grantAgreement.grantPaymentData.granteeName = `${this.props.granteeOrgFirstName} ${this.props.granteeOrgLastName}`;
    grantAgreement.grantPaymentData.grantPurpose = this.props.grantPurpose.description;
    grantAgreement.grantPaymentData.grantAmount = this.props.grantAgreementAmount;
    grantAgreement.grantPaymentData.grantRecognitionObj = this.props.grantRecognition;
    grantAgreement.grantPaymentData.accountName = this.props.accountName;
    grantAgreement.grantPaymentData.ein = this.props.selectedCharityEin;
    grantAgreement.grantPaymentData.payments = paymentList;
    grantAgreement.grantPaymentData.dues = dueList;
    grantAgreement.grantPaymentData.reportingFromOrganization = "";
    grantAgreement.grantPaymentData.anonymous =
      this.props.grantRecognition.grantRecognition == "30";
  }

  paymentFormatter = () =>
    this.props.payment && this.props.payment.map(item => ({
      requestedDate: item.intendedPaymentDate,
      reportingFromOrganization: item.reportRequirement,
      amount: item.grantAmountStr
    }));

  dueDateFormatter = () =>
    this.props.payment && this.props.payment.filter(item => {
      if(item.grantRequirementDueDate) {
        return item.grantRequirementDueDate
      }
    });

  openPreview = isOrganization => {
    try {
      this.state.grantPaymentData.reportingFromOrganization = isOrganization;
      this.setState({
        previewPopup: true
      });
    } catch (error) {
      recordError(error);
    }
  };

  openGrantPaymentLetter = visible => {
    this.setState({
      grantPaymentLetter: visible
    });
  };

  closePreview = () => {
    this.setState({
      previewPopup: false
    });
  };
  includeAdvInfo = () => {
    const otherIndDoNotIncAcctAdv = this.props.grantPurpose.otherIndDoNotIncAcctAdv;
    if (otherIndDoNotIncAcctAdv && otherIndDoNotIncAcctAdv === "on")
    return false
    else if (otherIndDoNotIncAcctAdv && otherIndDoNotIncAcctAdv === "off")
    return true 
    else return this.props.grantRecognition.includeAdvisorInfo 
  };
   render() {
    return (
      <PreviewLetterWrapper>
        <div id="myMm" />
        {this.props.type && this.props.type == "edit" ? (
          <DisplayFlex>
            <LogoWrap>
            <PreviewLetterLogo src={PreviewLetterImage} alt="previewImage" />
            </LogoWrap>
            <PreviewLetterContent postlink>
              {" "}
              that will be sent to the grantee organization.
            </PreviewLetterContent>
            <GrantAgreementUnderlineLink id="anrPrwLetter">
              Preview Letter Page
            </GrantAgreementUnderlineLink>
          </DisplayFlex>
        ) : (
            <div>
              <LetterWrapper>
                <DisplayFlex>
                  <Block mr={3} mt={5}>
                    <PreviewLetter noBorderTop noPadding noBorderBottom grantAgreement
                      cnt="To preview the grant agreement letter we'll send to the grantee organization"
                      charityName={this.props.selectedCharityName}
                      charityAddress={this.props.selectedCharityAddress}
                      startDate={this.props.payment && this.props.payment[0].intendedPaymentDate}
                      grantAmount={this.props.grantAgreementAmount}
                      grantPurposeName={this.props.grantPurpose.description}
                      additionalComments={this.props.grantPurpose.additionalComments}
                      notifyFirstName={this.props.grantRecognition.notifyFirstName}
                      notifyLastName={this.props.grantRecognition.notifyLastName}
                      inMemoryOfName={this.props.grantRecognition.inMemoryOfName}
                      inHonorOfName={this.props.grantRecognition.inHonorOfName}
                      thirdParty={this.props.grantRecognition.thirdParty || this.props.grantRecognition.thankIndividualName}
                      includeAdvisorInfo= {this.includeAdvInfo()}
                      grantRecognition={this.props.grantRecognition.grantRecognition}
                      advisors={this.props.advisors}
                      publishPermission={this.props.permissionToPublish}
                      codeValueMappingData={this.props.codeValueMappingData}
                    />
                  </Block>
                </DisplayFlex>
              </LetterWrapper>
              <Block mx={10} h={10}></Block>
              <LetterWrapper>
                <PreviewFlex>
                  <PreviewLetterLogo src={PreviewLetterImage} alt="previewLetter" />
                  <Block mr={5} mt={5}>
                    <PreviewLetterContent value="previewClicked">
                      To view the grant agreement document
                      <GrantAgreementUnderlineLink
                        id="anrgrantAgreementDocument"
                        onClick={() => this.openPreview(false)}
                      >
                        {" "}
                        click here.
                    </GrantAgreementUnderlineLink>
                  </PreviewLetterContent>
                  </Block>
                </PreviewFlex>
              </LetterWrapper>
            </div>
          )}

        {this.state.previewPopup && (
          <PreviewLetterPopup
            grantPaymentData={this.state.grantPaymentData}
            closePreview={this.closePreview}
          />
        )}
      </PreviewLetterWrapper>
    );
  }
}

PreviewLetters.propTypes = {
  accountName: PropTypes.string,
  advisors: PropTypes.array,
  codeValueMappingData: PropTypes.object,
  grantAgreementAmount: PropTypes.string,
  grantPurpose: PropTypes.object,
  grantRecognition: PropTypes.object,
  granteeOrgFirstName: PropTypes.string,
  granteeOrgLastName: PropTypes.string,
  payment: PropTypes.array,
  permissionToPublish: PropTypes.bool,
  selectedCharityAddress: PropTypes.object,
  selectedCharityEin: PropTypes.string,
  selectedCharityName: PropTypes.string
}

export default PreviewLetters;
